import {createFileRoute} from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {ROLES} from "@/lib/auth/roles";
import ReportEnquiryPage from "@/modules/enquiries/report";
import {ENQUIRY_REPORT_PATH} from "@/utils/urls";

export const Route = createFileRoute(ENQUIRY_REPORT_PATH)({
  component: ReportEnquiry,
  loader: async ({params}) => {
    const {id} = params
    return {id}
  },
  beforeLoad: ({params}) => {
    return {
      breadcrumbs: [
        {label: 'Enquiries', path: '/v2/enquiries'},
        {label: 'Report', path: `/v2/enquiries/report/${params.id}`}
      ],
      children: null,
      canSwitchFirm: false
    }
  }
})

function ReportEnquiry() {
  return (
    <Authorisation roles={[ROLES.ROLE_EDIT_ENQUIRIES]} permissions={[]} forbiddenFallback={<Unauthorized/>}>
      <div className={'flex flex-col items-left justify-center  max-sm:p-5'}>
        <ReportEnquiryPage/>
      </div>
    </Authorisation>
  )
}
